// ─── CATEGORY ICON SYSTEM ─────────────────────────────────────────────────────
// BRAND.md §7: no emoji in UI. One Lucide glyph per category, rendered as SVG
// (currentColor, 1.75px stroke) — identical on every OS and browser.
//
// Keys cover BOTH the English trade names and the taxonomy ids found in
// products.category (live list pulled from the DB, 2026-07-06). Unknown or
// future categories fall back to the Package icon.

import {
  Utensils, UtensilsCrossed, Coffee, CookingPot, ChefHat, Soup, Box, Clock,
  Shirt, Lamp, Archive, Layers, Image, ShoppingBasket, Rows3, Package,
  Sparkles, Brush, Wine, Cake, HandPlatter, Microwave, Bath, CupSoda,
  Briefcase, Frame, Armchair, Flame, LayoutGrid,
} from 'lucide-react';
import React from 'react';

const CATEGORY_ICONS = {
  // custom trade categories (English names as stored in products.category)
  'Porcelain':                    Utensils,
  'Mugs & Thermal Flasks':        Coffee,
  'Spice Jars':                   Soup,
  'Plasticware':                  Box,
  'Wall Clocks':                  Clock,
  'Clothes Organizers':           Shirt,
  'Side Tables':                  Lamp,
  'Metal Bread Bins & Spice Sets': Archive,
  'Metal Organizers':             Layers,
  'Wall Art':                     Image,
  'Basket & Tissue Box Sets':     ShoppingBasket,
  'Stands & Racks':               Rows3,
  'Glassware':                    Wine,
  'Dough Mixers':                 Cake,
  'Serving Trays':                HandPlatter,
  'Tray Sets':                    HandPlatter,
  'Turbo Ovens':                  Microwave,
  'Console Tables':               Lamp,
  'Cutlery Cases':                Briefcase,
  'Mirrors':                      Frame,
  'Chairs':                       Armchair,
  'Grill':                        Flame,

  // taxonomy ids (src/data/categories.js)
  'kitchen-tools': CookingPot,
  'cookware':      ChefHat,
  'tableware':     UtensilsCrossed,
  'food-storage':  Package,
  'cleaning':      Brush,
  'bathroom':      Bath,
  'drinkware':     CupSoda,
  'new-arrivals':  Sparkles,
  'all':           LayoutGrid,
  'other':         Package,
};

export function categoryIcon(category) {
  return CATEGORY_ICONS[category] || Package;
}

// Drop-in SVG icon: <CategoryIcon category={p.category} size={16} />
export function CategoryIcon({ category, size = 16, style, ...rest }) {
  const Icon = categoryIcon(category);
  return (
    <Icon
      size={size}
      strokeWidth={1.75}
      aria-hidden="true"
      style={{ flexShrink: 0, verticalAlign: '-0.125em', ...style }}
      {...rest}
    />
  );
}
